import React, { useState } from 'react';
import StateSelectionModal from '@RN_UI_Lib/StateSelectionModal';
import { StatesData } from '../../Helpers/constants';
import { StateSelectionProps } from '../../Helpers/interfaces';

function StateSelection(props: StateSelectionProps) {
  const { closeHandler, selectHandler } = props;
  const [searchString, setSearchString] = useState('');
  const [states, setStates] = useState(StatesData);

  const modifiedStatesData = (val: string) => {
    setSearchString(val);

    if (val === '') {
      setStates(StatesData);
      return;
    }

    const filteredStates = StatesData.filter((state) => {
      const stateLabel = state.label?.toLowerCase();
      return stateLabel?.includes(val?.toLowerCase());
    });

    setStates(filteredStates);
  };

  return (
    <StateSelectionModal
      theme={'MMT'}
      statesData={states}
      headerLabel={'Select the State'}
      searchString={searchString}
      onClose={closeHandler}
      onSearchChange={(val: any) => modifiedStatesData(val)}
      onSelect={(val: { label: any }) => selectHandler(val.label)}
    />
  );
}

export default StateSelection;
